import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";

const getSid = () => {
  let sid = localStorage.getItem("vr_sid");
  if (!sid) {
    sid = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("vr_sid", sid);
  }
  return sid;
};

export const trackEvent = (path, kind = "cta") => {
  api.post("/track/view", { path, kind, sid: getSid() }).catch(() => {});
};

const KIND_MAP = { journal: "journal", share: "share", recap: "recap", reply: "reply", auth: "auth", "hoe-werkt-het": "help", "wat-is-nieuw": "updates" };
const GENERIC_SEGS = ["journal", "share", "recap", "reply", "trip"];

const classify = (path) => {
  if (path === "/") return ["landing", "/"];
  const seg = path.split("/")[1];
  const kind = KIND_MAP[seg] || "app";
  const generic = GENERIC_SEGS.includes(seg) ? `/${seg}/:id` : path;
  return [kind, generic];
};

export const PageTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const [kind, path] = classify(pathname);
    api.post("/track/view", { path, kind, sid: getSid() }).catch(() => {});
  }, [pathname]);
  return null;
};
